"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M20.485 3.515a.55.55 0 0 0-.757 0 .538.538 0 0 0 0 .756A10.852 10.852 0 0 1 22.93 12c0 6.028-4.903 10.931-10.93 10.931-6.028 0-10.932-4.903-10.932-10.931A10.89 10.89 0 0 1 11.465 1.082v2.221A8.706 8.706 0 0 0 3.276 12c0 4.811 3.913 8.725 8.724 8.725 4.81 0 8.724-3.914 8.724-8.725 0-2.33-.907-4.52-2.554-6.169a.536.536 0 0 0-.379-.156h-.001a.526.526 0 0 0-.376.156.531.531 0 0 0-.001.756A7.604 7.604 0 0 1 19.655 12c0 4.221-3.435 7.656-7.655 7.656-4.222 0-7.656-3.435-7.656-7.656a7.647 7.647 0 0 1 7.121-7.626v2.209C8.7 6.854 6.551 9.212 6.551 12A5.455 5.455 0 0 0 12 17.449 5.455 5.455 0 0 0 17.448 12a5.412 5.412 0 0 0-1.596-3.852.55.55 0 0 0-.757 0 .537.537 0 0 0 .001.756A4.348 4.348 0 0 1 16.379 12 4.385 4.385 0 0 1 12 16.379 4.385 4.385 0 0 1 7.62 12c0-2.196 1.678-4.078 3.845-4.344v3.107A1.352 1.352 0 0 0 10.646 12c0 .746.608 1.354 1.354 1.354.746 0 1.353-.608 1.353-1.354 0-.538-.326-1.025-.819-1.237V.535A.535.535 0 0 0 12 0C5.383 0 0 5.384 0 12c0 6.618 5.383 12 12 12s12-5.382 12-12c0-3.205-1.248-6.219-3.515-8.485",
    clipRule: "evenodd"
  })]
});